import ErrorLogList from "./List";

export default ErrorLogList;
